import styled from 'styled-components';

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;

  button {
    width: 250px;
    &:nth-child(2) {
      margin-left: 20px;
    }
  }
`;
